import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

import { CustomLink } from "../link/Link";
import WalletSymbols from "../WalletSymbols";
import Text from "../text/Text";
import { checkLimits, swap } from "../messages";

const LimitExhaustedMsgBox = ({
  isFromBrowser,
  message,
  subMessage,
  module,
}) => {
  const navigate = useNavigate();
  const handleNavigateToLimits = () => {
    if (module === swap) {
      navigate("/settings/limits?tab=swap/convert");
    } else {
      navigate(`/settings/limits?tab=${module}`);
    }
  };
  return (
    <Box
      className="common-error-msg-box"
      sx={{
        marginBottom: isFromBrowser ? "12px" : "8px",
      }}
    >
      <Box display="flex" flexDirection="column" flex={1} gap={1}>
        <Text
          className="error-text"
          size={isFromBrowser ? 16 : 14}
          font="semibold"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <WalletSymbols
            symbol="error"
            sx={{ color: "#fd371e", marginRight: "4px" }}
          />
          {message}
        </Text>
        <Text
          className="error-text"
          size={isFromBrowser ? 14 : 12}
          font="regular"
        >
          {subMessage}
        </Text>

        <CustomLink
          color="primary"
          style={{
            fontSize: "14px",
            fontWeight: "600",
            marginTop: "4px",
          }}
          onClick={handleNavigateToLimits}
        >
          {checkLimits}
        </CustomLink>
      </Box>
    </Box>
  );
};

export default LimitExhaustedMsgBox;
